export default __webpack_public_path__ + "img/34e6f93bc9c3ad71ca02c393f2128653.svg";